"use client";

import { LayoutList, Maximize } from "lucide-react";
import { Button } from "@/components/assets/button/button";

type LeftSidebarToggleProps = {
  leftSidebarOpen: boolean;
  showDetail: boolean;
  onLeftSidebarChange: (open: boolean) => void;
  toggleLabel: string;
};

export function LeftSidebarToggle({
  leftSidebarOpen,
  showDetail,
  onLeftSidebarChange,
  toggleLabel,
}: LeftSidebarToggleProps) {
  const handleToggle = () => {
    if (leftSidebarOpen) {
      // If sidebar is open, collapse it (Fullscreen mode)
      onLeftSidebarChange(false);
    } else {
      // If sidebar is closed, just open it (keep detail if showing)
      onLeftSidebarChange(true);
    }
  };

  return (
    <Button className="-ml-2" onClick={handleToggle} size="xs" variant="ghost">
      {leftSidebarOpen ? (
        <>
          <Maximize className="h-2 w-2" />
          Expand
        </>
      ) : showDetail ? (
        <>
          <LayoutList className="h-2 w-2" />
          Show {toggleLabel} list
        </>
      ) : (
        `Show ${toggleLabel} list`
      )}
    </Button>
  );
}
